class weatherView {
  #parentElement = document.querySelector(".location-info-container");
  #data;
  tempLocationMain;
  tempMain;
  locationDetailsContainer;

  render(data) {
    this.#data = data;

    this.#clear();
    const markup = this.#generateMarkup();
    this.#parentElement.insertAdjacentHTML("afterbegin", markup);
    this.tempLocationMain = document.querySelector(".location-temp-main");
    this.tempMain = document.querySelector(".temp-main");
  }

  #clear() {
    this.#parentElement.innerHTML = "";
  }

  #generateMarkup() {
    return `
  
    <div class="location-info-flex">
      <div class="location-icon-main">
        <img
          src="${this.#data.weatherData.current.icon}"
          alt="cloudy day icon"
          class="main-icon icon"
        />
      </div>
      <div class="location-temp-main">
        <span class="temp-main">${
          this.#data.tempUnit === "celcius"
            ? this.#data.weatherData.current.temperature
            : this.#data.weatherData.current.temperatureFarenheight
        }</span>
        <div class="temp-unit-container">
          <span class="temp-unit temp-unit--active">°C</span
          ><span>|</span><span class="temp-unit">°F</span>
        </div>
      </div>
    </div>`;
  }

  addHandlerChangeTemp(handler) {
    this.tempLocationMain.addEventListener("click", function () {
      handler();
    });
  }

  renderTempUnit() {
    this.tempLocationMain.innerHTML = "";
    const markup = this.generateTempUnitMarkup();
    this.tempLocationMain.insertAdjacentHTML("afterbegin", markup);
    this.locationDetailsContainer.remove();
  }

  generateTempUnitMarkup() {
    return `<span class="temp-main">${
      this.#data.tempUnit === "celcius"
        ? this.#data.weatherData.current.temperature
        : this.#data.weatherData.current.temperatureFarenheight
    }</span>
      <div class="temp-unit-container">
                  <span class="temp-unit temp-unit--active">${
                    this.#data.tempUnit === "celcius"
                      ? this.#data.weatherData.current.temperatureUnit
                      : this.#data.weatherData.current
                          .temperatureFarenheightUnit
                  }</span
                  ><span>|</span><span class="temp-unit">${
                    this.#data.tempUnit === "celcius"
                      ? this.#data.weatherData.current
                          .temperatureFarenheightUnit
                      : this.#data.weatherData.current.temperatureUnit
                  }</span>
                </div>
              </div>`;
  }

  renderWeatherDetails() {
    const markup = this.generateDetailsMarkup();
    this.#parentElement.insertAdjacentHTML("beforeend", markup);
    this.locationDetailsContainer = document.querySelector(
      ".location-details-main"
    );
  }

  generateDetailsMarkup() {
    return `
    <div class="location-details-main">
    <span class="location-temp-feelslike">Feels Like:</span>
    <span class="feelslike-value">${
      this.#data.tempUnit === "celcius"
        ? this.#data.weatherData.current.apparantTemperature
        : this.#data.weatherData.current.apparantTemperatureFarenheight
    }</span>
    <span class="feelslike-unit">${
      this.#data.tempUnit === "celcius"
        ? this.#data.weatherData.current.temperatureUnit
        : this.#data.weatherData.current.temperatureFarenheightUnit
    }</span><br>
    <span class="location-precipitation">Precipitation: </span
    ><span class="precipitation-value">${
      this.#data.weatherData.current.precipitationProbabilty
    }</span><span class="precipitation-unit">${
      this.#data.weatherData.current.precipitationProbabiltyUnit
    }</span><br />
    <span class="location-humidity">Humidity: </span
    ><span class="humidity-value">${
      this.#data.weatherData.current.relativeHumidity
    }</span><span class="humidity-unit">${
      this.#data.weatherData.current.relativeHumidityUnit
    }</span><br />
    <span class="location-wind">Wind: </span
    ><span class="wind-value">${
      this.#data.weatherData.current.windSpeed
    }</span><span class="wind-unit">${
      this.#data.weatherData.current.windSpeedUnit
    }</span>  <br> 
  <span class="weather-decription">${
    this.#data.weatherData.current.description
  }</span>
  </div>
  `;
  }
}

export default new weatherView();
